import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserStateService } from '../../../core/services/user-state.service';

@Component({
  standalone: true,
  selector: 'app-update-subscription',
  templateUrl: './update-subscription.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateSubscriptionComponent implements OnInit {
  private userStateService = inject(UserStateService);
  private router = inject(Router);

  ngOnInit(): void {
    // Force a refresh of the user's onboarding/subscription state from the backend.
    // This triggers a Stripe sync and updates the user's AccountStatus in our DB.
    this.userStateService.refreshState().subscribe({
      next: () => {
        this.router.navigate(['/dashboard'], { replaceUrl: true });
      },
      error: () => {
        // On error, send the user to the profile page to try again.
        this.router.navigate(['/profile'], { replaceUrl: true });
      }
    });
  }
}
